import { formatUserName } from "@impero-com/common/utils/formatting";
import { useTranslation } from "@impero-com/common/utils/i18n";
import { TableToolbar, TextTool } from "@impero-com/ui";
import { useOutletContext } from "react-router-dom";

import { EntitiesAccessRightsUpdateScope } from "api/generated/model";
import { AssignmentTable } from "org/user/components/AssignmentTable";
import { useControlEntitiesForUserQuery } from "org/user/queries/useControlEntitiesForUserQuery";
import { OutletContext } from "org/user/UserViewPage";
import { getFilterModeConfig } from "utils/table/getFilterModeConfig";

import { RemoveAccessRightModal } from "./RemoveAccessRightModal";
import { useRemoveControlEntityRights } from "./useRemoveControlEntityRights";
import { useUserControlEntitiesListTable } from "./useUserControlEntitiesListTable";

export function UserControlEntitiesList() {
    const { user } = useOutletContext<OutletContext>();
    const { t } = useTranslation();

    const { data: entities } = useControlEntitiesForUserQuery(user.id);
    const { table, getFilterComponent, tableId } =
        useUserControlEntitiesListTable(entities);

    const removal = useRemoveControlEntityRights({
        userId: user.id,
        selectedRows: table.getFilteredSelectedRowModel().rows,
        deselectAll: () => table.resetRowSelection(),
    });

    return (
        <div>
            <RemoveAccessRightModal
                open={removal.isModalOpen}
                onClose={removal.close}
                onConfirm={removal.remove}
                loading={removal.isRemoving}
                user={formatUserName(user)}
                plan={removal.plan}
                understood={removal.understood}
                onUnderstoodChange={removal.setUnderstood}
            />
            <AssignmentTable
                table={table}
                tableId={tableId}
                getFilterComponent={getFilterComponent}
                modeConfig={getFilterModeConfig(t)}
                toolbar={
                    <TableToolbar>
                        <TextTool
                            state={removal.toolState(
                                EntitiesAccessRightsUpdateScope.control
                            )}
                            onClick={() =>
                                removal.open(
                                    EntitiesAccessRightsUpdateScope.control
                                )
                            }
                        >
                            {t(
                                "AccessAndAssignment_Tool_RemoveControlAccessRight"
                            )}
                        </TextTool>
                        <TextTool
                            state={removal.toolState(
                                EntitiesAccessRightsUpdateScope.risk
                            )}
                            onClick={() =>
                                removal.open(
                                    EntitiesAccessRightsUpdateScope.risk
                                )
                            }
                        >
                            {t(
                                "AccessAndAssignment_Tool_RemoveRiskAccessRight"
                            )}
                        </TextTool>
                    </TableToolbar>
                }
            />
        </div>
    );
}
